module.exports = __webpack_public_path__ + "static/media/Fabric-phone-mockup.624f5700.png";